import clsx from "clsx"
import React from "react"

import { Spinner, Tooltip } from "components"
import classes from "./Button.module.scss"

const Button = props => {
  const {
    tooltip = "",
    variant = "solid",
    className = "",
    color = "primary",
    children,
    loading = false,
    disabled = false,
    onClick = () => { },
    fullWidth = false,
    ...otherProps
  } = props

  return (
    <Tooltip title={tooltip}>
      <button
        disabled={disabled}
        onClick={() => !loading && onClick()}
        className={clsx(className,
          variant === "solid" && classes[`solid-${color}`],
          variant === "outline" && classes[`outline-${color}`],
          variant === "pill" && classes[`pill-${color}`],
          variant === "pill-outline" && classes[`pill-outline-${color}`],
          disabled && classes["disabled"],
          fullWidth && classes["full-width"]
        )}
        {...otherProps}
      >
        {loading ? <Spinner /> : children}
      </button>
    </Tooltip>
  )
}

export default Button